if (!customElements.get("product-form")) {
  customElements.define(
      "product-form",
      class ProductForm extends HTMLElement {
        constructor() {
          super();
          this.selectors = {
            form: "form",
            inputId: "[name=id]",
            submitButton: '[name="add"]',
            errorWrapper: ".f-product-form__error-message-wrapper",
            customFields: ["[data-product-custom-field]"],
          };

          this.domNodes = queryDomNodes(this.selectors, this);
          this.form = this.domNodes.form;
          this.submitButton = this.domNodes.submitButton;
          this.domNodes.inputId.disabled = false;
          this.Notification = window.FoxTheme.Notification;
          this.notificationType = this.dataset.notificationType;
          this.customFields = document.querySelectorAll(this.selectors.customFields);
          this.cartDrawer = document.querySelector("cart-drawer");
          this.mainCart = document.querySelector("cart-items");
          this.type = this.dataset.type;
          this.variantIdInput = this.domNodes.inputId;

          this.errorWrapper = this.type === "product-card"
              ? this.closest(".product-card")
              : this.domNodes.errorWrapper;

          this.form && this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }

        validateForm(form) {
          const missingFields = [];
          if (!form) return missingFields;
          const fieldSelectors =
              '[data-product-custom-field] [name][required]:not([hidden]):not([type="hidden"])';
          const requiredFields = form.querySelectorAll(fieldSelectors);
          requiredFields.forEach((field) => {
            field.classList.remove("form-control--warning");
            if (field.type === "radio") {
              const buttons = form.querySelectorAll(
                  `input[name="${field.name}"]`
              );
              const selected = Array.from(buttons).some((btn) => btn.checked);
              if (!selected) {
                missingFields.push(field);
                field.classList.add("form-control--warning");
              }
            } else if (!field.value) {
              missingFields.push(field);
              field.classList.add("form-control--warning");
            }
          });
          return missingFields;
        }

        getSectionsToRender() {
          const sections = [];

          if (this.cartDrawer) {
            sections.push(...this.cartDrawer.getSectionsToRender());
          }

          if (this.mainCart) {
            sections.push(...this.mainCart.getSectionsToRender());
          }

          return sections;
        }

        async onSubmitHandler(evt) {
          evt.preventDefault();
          const missing = this.validateForm(this.form.closest(".f-product-single__blocks"));

          if (missing && missing.length > 0) {
            return this.Notification.show({
              target: this.domNodes.errorWrapper,
              method: "appendChild",
              type: "warning",
              message: window.FoxThemeStrings.requiredField,
            });
          }

          if (this.submitButton.classList.contains("btn--loading")) return;

          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.classList.add("btn--loading");

          const config = {
            method: "POST",
            headers: {
              Accept: "application/javascript",
              "X-Requested-With": "XMLHttpRequest",
            },
          };

          const formData = new FormData(this.form);
          const sections = this.getSectionsToRender();

          // Get quantity being added - we need this for the initial check
          const addingQuantity = parseInt(formData.get("quantity")) || 1;

          if (this.cartDrawer) {
            formData.append(
                "sections",
                this.cartDrawer.getSectionsToRender().map((section) => section.id)
            );
          }

          if (this.mainCart) {
            formData.append(
                "sections",
                this.mainCart.getSectionsToRender().map((section) => section.section)
            );
          }

          if (this.mainCart || this.cartDrawer) {
            formData.append("sections_url", window.location.pathname);
          }

          config.body = formData;

          const { FoxThemeSettings, FoxThemeStrings } = window;

          try {
            const response = await fetch(`${FoxThemeSettings.routes.cart_add_url}`, config);
            const responseData = await response.json();

            if (responseData.status) {
              window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: responseData.description,
                message: responseData.message,
              });

              this.error = true;
              return this.Notification.show({
                target: this.notificationType === "toast" ? document.body : this.errorWrapper,
                method: "appendChild",
                type: "warning",
                message: responseData.description || responseData.message,
                last: 3000,
                sticky: this.notificationType === "toast",
              });
            }

            if (!FoxThemeSettings.cart.openDrawerWhenAdded || FoxThemeSettings.cart.cartType === "page") {
              this.Notification.show({
                target: this.errorWrapper,
                method: "appendChild",
                type: "success",
                message: FoxThemeStrings.item_added,
                last: 3000,
                sticky: this.notificationType === "toast",
              });
            }

            if (FoxThemeSettings.cart.cartType === "page") {
              const state = await FoxThemeCartHelpers.getState();
              FoxThemeCartHelpers.updateCartCount(state.item_count);
            }

            this.error = false;

            // Check if we need to handle art fee for direct high-quantity additions
            if (addingQuantity >= 2) {
              // Check if this product has art fee metafield
              const productHasArtFee = await this.checkIfProductHasArtFee(formData.get("id"));

              if (productHasArtFee) {
                // Add a small delay to ensure the product is fully added to cart
                setTimeout(() => {
                  // Emit cart update event - this will trigger art fee handling in cart.js
                  window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, responseData);
                  sessionStorage.setItem('openCartDrawer', 'true');
                }, 100);
                return; // Exit early, let cart.js handle the art fee addition
              }
            }

            // Emit regular cart update for normal cases
            window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, responseData);

          } catch (error) {
            console.error('Error in form submission:', error);
          } finally {
            this.submitButton.classList.remove("btn--loading");
            this.submitButton.removeAttribute("aria-disabled");
          }
        }

        // Check if the current product has art fee metafield
        async checkIfProductHasArtFee(variantId) {
          try {
            // Get the current product from the page (since we're on the product page)
            const productData = window.product || window.meta?.product;
            if (productData && productData.metafields && productData.metafields.art_fee) {
              return true;
            }

            // Fallback: check via cart metafields view (less reliable for current product)
            const itemsResponse = await fetch(`/cart?view=metafields`);
            const itemsData = await itemsResponse.text();
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = itemsData;

            // Look for any items with art fee - if we find any, it's likely this product has one too
            const artFeeItems = tempDiv.querySelectorAll('[data-art-fee]');
            return artFeeItems.length > 0;

          } catch (error) {
            console.error('Error checking if product has art fee:', error);
            // Default to true to be safe - cart.js will handle the actual logic
            return true;
          }
        }
      }
  );
}
